/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpOptions } from './http-options.interface';

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  private _http = inject(HttpClient);

  get(url: string, options?: HttpOptions): Observable<any> {
    if (options) return this._http.get(url, options);

    return this._http.get(url);
  }

  getParams(filter: { [key: string]: any }): HttpParams {
    let params = new HttpParams();

    for (const key in filter) {
      // null também fica de fora: iria para a URL como a string "null" e o
      // ValidationPipe da API (whitelist/IsEnum) recusaria a requisição inteira
      if (Object.prototype.hasOwnProperty.call(filter, key) && filter[key] !== undefined && filter[key] !== null) {
        if (Array.isArray(filter[key])) {
          for (const value of filter[key]) {
            params = params.append(key, value);
          }
        } else {
          params = params.append(key, filter[key]);
        }
      }
    }

    return params;
  }
}
